// extracted by mini-css-extract-plugin
export var classNameInput = "messages-module--class-name-Input--o4zQ3";
export var emptyWrapper = "messages-module--empty-wrapper--onVYG";
export var messenger = "messages-module--messenger--YinQX";
export var searchBar = "messages-module--search-bar--u+3TM";
export var wrapper = "messages-module--wrapper--ngSA-";